<template>
  <div class="rotate-screen">
    <div class="rotate-screen__content">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="280"
        height="274"
        fill="none"
        viewBox="0 0 280 274"
      >
        <defs />
        <g fill="#292983" clip-path="url(#clip0)">
          <path
            d="M173.77 112.91h-67.56a6.22 6.22 0 00-6.21 6.21v35.76a6.22 6.22 0 006.21 6.21h67.58a6.22 6.22 0 006.21-6.2v-35.77a6.24 6.24 0 00-6.23-6.2zM114.4 157.1v-40.16h45.47v40.16H114.4zm-10.4-2.2v-35.77c0-1.2.98-2.2 2.21-2.2h4.18v40.17h-4.18c-1.22 0-2.2-1-2.2-2.2zm69.77 2.2h-9.92v-40.16h9.92c1.21 0 2.21.98 2.21 2.2v35.75c0 1.21-.98 2.2-2.2 2.2z"
          />
          <path d="M168.09 132.95v8.12a2 2 0 104.02 0v-8.12a2 2 0 10-4.02 0z" />
        </g>
        <path
          fill="#292983"
          d="M187.17 95.16a36.15 36.15 0 00-18.71-4.72A40.2 40.2 0 00156 92.66l8.45 4.51a2.04 2.04 0 11-1.92 3.6l-11.7-6.25a2.04 2.04 0 01-.97-3.64l7-11.26a2.04 2.04 0 113.47 2.16l-4.05 6.5c3.93-1.2 8-1.84 12.11-1.92a40.24 40.24 0 0120.82 5.27 39.44 39.44 0 0119.04 26.3c2.11 9.97.54 20.83-4.21 29.06a2.04 2.04 0 11-3.53-2.04c4.26-7.38 5.66-17.16 3.75-26.17a35.4 35.4 0 00-17.1-23.62zM77.18 125.06c.97.57 1.3 1.81.74 2.79-4.26 7.38-5.66 17.16-3.75 26.17a35.4 35.4 0 0017.1 23.62 36.14 36.14 0 0018.7 4.72c4.25-.07 8.45-.82 12.47-2.21l-8.46-4.52a2.04 2.04 0 011.92-3.6l11.7 6.25a2.04 2.04 0 01.97 3.64l-7 11.26a2.04 2.04 0 11-3.47-2.16l4.05-6.5c-3.93 1.2-8 1.84-12.1 1.92a40.23 40.23 0 01-20.82-5.27 39.43 39.43 0 01-19.05-26.3c-2.11-9.97-.54-20.83 4.21-29.06a2.04 2.04 0 012.79-.75z"
        />
        <defs>
          <clipPath id="clip0">
            <path
              fill="#fff"
              d="M0 0h80v80H0z"
              transform="rotate(-90 138.5 38.5)"
            />
          </clipPath>
        </defs>
      </svg>
      <div>Переверните устройство для&nbsp;просмотра</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.rotate-screen {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
}
</style>
